// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1_rcw","cls2":"UserTooltip-cls2_rrM UserTooltip-cls1_rcw"};